<template>
  <div class="faq-wrap">
    <!-- 页面标题 -->
    <div class="page-title">常见问题</div>
    
    <!-- 账号类问题 -->
    <div class="faq-section">
      <div class="faq-section-title">
        <h4>账号类问题</h4>
        <div class="section-divider"></div>
      </div>
      <ul class="faq-list">
        <li 
          v-for="(item, index) in accountFaqs" 
          :key="index" 
          @click="toggleFaq('account', index)" 
          :class="{ active: item.active }"
          class="faq-item"
        >
          <div class="faq-question">
            <span class="question-text">{{ item.question }}</span>
            <i class="arrow-icon"></i>
          </div>
          <div class="faq-answer" v-show="item.active">
            <!-- 使用v-html解析HTML内容 -->
            <p v-for="(line, i) in item.answer" :key="i" class="answer-line" v-html="line"></p>
          </div>
        </li>
      </ul>
    </div>

    <!-- 游戏类问题 -->
    <div class="faq-section">
      <div class="faq-section-title">
        <h4>游戏类问题</h4>
        <div class="section-divider"></div>
      </div>
      <ul class="faq-list">
        <li 
          v-for="(item, index) in gameFaqs" 
          :key="index" 
          @click="toggleFaq('game', index)" 
          :class="{ active: item.active }"
          class="faq-item"
        >
          <div class="faq-question">
            <span class="question-text">{{ item.question }}</span>
            <i class="arrow-icon"></i>
          </div>
          <div class="faq-answer" v-show="item.active">
            <!-- 使用v-html解析HTML内容 -->
            <p v-for="(line, i) in item.answer" :key="i" class="answer-line" v-html="line"></p>
          </div>
        </li>
      </ul>
    </div>

    <!-- 帮助提示 -->
    <div class="help-prompt">
      <p>还有其他问题？<a href="javascript:;" @click="contactSupport" class="contact-link">联系在线客服</a></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Faq',
  data() {
    return {
      accountFaqs: [
        {
          question: "如何注册？",
          answer: [
            "开户方式有两种：",
            "1、请点击网站首页“<span class='highlight'>免费开户</span>”按钮，按照界面所规定的填写内容进行自助开户。",
            "2、联系<span class='highlight'>在线客服</span>提供您的联系电话和取款银行卡姓名即可开出游戏账号。"
          ],
          active: false
        },
        {
          question: "忘记密码怎么办？",
          answer: [
            "(1) 您可以自行找回密码：于登录页面点击[忘记账号、密码？]，选择[我忘记密码了]，依据提示自助找回密码即可。",
            "(2) 您可以联系24小时<span class='highlight'>在线客服</span>，通过客服人员免费电话协助找回账号密码。"
          ],
          active: false
        },
        {
          question: "怎么充币？",
          answer: [
            "登录账号后进入充币页面，选择您要的充币方式并输入金额，根据页面提示进行扫码转币或者人民币买币，交易完成后充值金额将会自动存入您的网站账户中。更详细的操作可以到首页上的“<span class='highlight'>数字币充提指南</span>”查看。"
          ],
          active: false
        }
      ],
      gameFaqs: [
        {
          question: "游戏结束后如何提币？",
          answer: [
            "登录账号后进入提币页面，输入提币金额（第一次提币须绑定钱包）后选择提币钱包，确认提币后约30分钟内转入您的钱包。更详细的操作可以到首页上的“<span class='highlight'>数字币充提指南</span>”查看。"
          ],
          active: false
        },
        {
          question: "提币到账如何变现？",
          answer: [
            "登录账号后进入提币页面，点选“<span class='highlight'>卖币变现</span>”进入后选择您要的交易所，输入卖币数量进行提交，使用您的钱包向交易所提供的转币地址进行转账，交易成功后变现的金额会自动转入您提供的指定账户中。更详细的操作可以到首页上的“<span class='highlight'>数字币充提指南</span>”查看。"
          ],
          active: false
        }
      ]
    };
  },
  methods: {
    // 统一的FAQ切换方法
    toggleFaq(type, index) {
      // 如果点击的是已展开的项，则关闭
      if (this[`${type}Faqs`][index].active) {
        this[`${type}Faqs`][index].active = false;
        return;
      }
      
      // 关闭同类型下的其他所有项
      this[`${type}Faqs`].forEach((item, i) => {
        if (i !== index) item.active = false;
      });
      
      // 展开当前项
      this[`${type}Faqs`][index].active = true;
    },
    
    // 联系客服处理方法
    contactSupport() {
      // 根据实际需求选择合适的客服交互方式
      
      // 方式1: 跳转到客服页面
      this.$router.push('/kefu');
      
      // 方式2: 调用父组件的客服方法（如果存在）
      // if (this.$parent.openCustomerService) {
      //   this.$parent.openCustomerService();
      // }
    },
  }
};
</script>

<style lang="scss" scoped>
/* 样式部分保持不变 */
.faq-wrap {
  max-width: 900px;
  margin: 0 auto;
  padding: 30px 20px 60px;
  background: #f8f9fa;
  min-height: 100vh;
  font-family: 'Helvetica', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  box-sizing: border-box;
}

// 页面标题
.page-title {
  font-size: 24px;
  font-weight: 700;
  color: #222;
  margin-bottom: 30px;
  text-align: center;
  letter-spacing: 0.5px;
}

// 问题区块
.faq-section {
  margin-bottom: 40px;
  position: relative;
}

.faq-section-title {
  margin-bottom: 20px;
}

.faq-section-title h4 {
  font-size: 19px;
  font-weight: 600;
  color: #333;
  margin: 0 0 8px 0;
  display: inline-block;
  position: relative;
  padding-right: 10px;
  background: #f8f9fa;
  z-index: 2;
}

.section-divider {
  height: 1px;
  background: #e0e0e0;
  position: relative;
  top: -10px;
  z-index: 1;
}

// 问题列表
.faq-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.faq-item {
  background: white;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  margin-bottom: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: hidden;
}

.faq-item:hover {
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.08);
}

.faq-item.active {
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

// 问题部分
.faq-question {
  padding: 16px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.question-text {
  font-size: 16px;
  color: #333;
  line-height: 1.4;
  flex: 1;
}

.arrow-icon {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-right: 2px solid #888;
  border-bottom: 2px solid #888;
  transform: rotate(45deg) translateY(-3px);
  transition: all 0.3s ease;
  flex-shrink: 0;
  margin-left: 15px;
}

.faq-item.active .arrow-icon {
  transform: rotate(225deg) translateY(3px);
  border-color: #ff6b6b;
}

// 答案部分
.faq-answer {
  padding: 0 20px 16px;
  color: #666;
  font-size: 14px;
  line-height: 1.7;
  background: #fafafa;
  border-top: 1px solid #f0f0f0;
  animation: fadeIn 0.3s ease;
}

.answer-line {
  margin: 0 0 12px 0;
  position: relative;
  padding-left: 0;
}

.answer-line:last-child {
  margin-bottom: 0;
}

// 高亮文本
.highlight {
  color: #ff6b6b;
  font-weight: 500;
  padding: 0 2px;
}

// 帮助提示
.help-prompt {
  margin-top: 50px;
  text-align: center;
  color: #777;
  font-size: 15px;
}

.contact-link {
  color: #ff6b6b;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s;
  cursor: pointer;
}

.contact-link:hover {
  color: #ff5252;
  text-decoration: underline;
}

// 动画效果
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

// 响应式调整
@media (max-width: 768px) {
  .faq-wrap {
    padding: 20px 15px 40px;
  }
  
  .page-title {
    font-size: 22px;
    margin-bottom: 20px;
  }
  
  .faq-section {
    margin-bottom: 30px;
  }
  
  .faq-section-title h4 {
    font-size: 18px;
  }
  
  .faq-question {
    padding: 14px 16px;
  }
  
  .question-text {
    font-size: 15px;
  }
  
  .faq-answer {
    padding: 0 16px 14px;
    font-size: 13px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/faq.vue